function getTailwindArbitraryValue(tailwindClass: string): string | null {
  const match = tailwindClass.match(/\[\s*(.*?)\s*\]/);
  return match ? match[1] : null;
}

export default getTailwindArbitraryValue;